// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"2d3d1d0c","125":"3403d889","179":"315bbe55"}[chunkId] + ".js";
};